import { defineStore } from 'pinia';

export interface Toast {
  id: number;
  message: string;
  subtext?: string;
  kind: 'success' | 'error';
}

interface State {
  toasts: Toast[];
}

const DISMISS_AFTER_MS = 3200;
// Errors carry a server message the reader needs time to take in.
const ERROR_DISMISS_AFTER_MS = 8000;
let nextId = 1;

export const useToastStore = defineStore('toast', {
  state: (): State => ({ toasts: [] }),
  actions: {
    show(message: string, subtext?: string) {
      const id = nextId++;
      this.toasts.push({ id, message, subtext, kind: 'success' });
      setTimeout(() => this.dismiss(id), DISMISS_AFTER_MS);
    },
    error(message: string, subtext?: string) {
      const id = nextId++;
      this.toasts.push({ id, message, subtext, kind: 'error' });
      setTimeout(() => this.dismiss(id), ERROR_DISMISS_AFTER_MS);
    },
    dismiss(id: number) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    },
  },
});
